var _path, _rect, _path2, _rect2, _line, _rect3, _line2, _rect4, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDepartmentStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.27,12.774c0-4.269,3.461-7.73,7.73-7.73s7.73,3.461,7.73,7.73"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.429,
    y: 12.774,
    width: 21.142,
    height: 24.183
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.206,28.365c0-3.2,2.594-5.794,5.794-5.794s5.794,2.594,5.794,5.794h-11.589Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.387,
    y: 28.365,
    width: 9.227,
    height: 8.591
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 28.365,
    x2: 21,
    y2: 36.723
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.297,
    y: 23.699,
    width: 6.985,
    height: 13.258
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.297,
    y1: 28.365,
    x2: 10.282,
    y2: 28.365
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.718,
    y: 23.699,
    width: 6.985,
    height: 13.258
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.718,
    y1: 28.365,
    x2: 38.703,
    y2: 28.365
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 14.174,
    y1: 17.04,
    x2: 27.826,
    y2: 17.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDepartmentStore);
export default __webpack_public_path__ + "static/media/indoor-department_store.857046efa227979acae5c8d7d8c8a153.svg";
export { ForwardRef as ReactComponent };